import React from 'react';
import { Box, Loader } from '@wix/design-system';
export const CenteredSpinningLoader = () => /*#__PURE__*/React.createElement(Box, {
  height: "100%",
  align: "center",
  verticalAlign: "middle"
}, /*#__PURE__*/React.createElement(Loader, {
  size: "medium"
}));
//# sourceMappingURL=CenteredSpinningLoader.js.map